export default "__VITE_ASSET__BzuFZuj3__"